<template>
  <v-toolbar dense class="mb-3" :dark="dark" flat color="amber lighten-2">
    <v-toolbar-title class="subtitle-2 font-weight-bold black--text">
      {{ title }}
    </v-toolbar-title>
  </v-toolbar>
</template>
<script>
export default {
  name: "list-title-bar",
  props: {
    title: {
      default: "Title"
    },
    dark: {
      default: false
    },
    color: {
      default: 'grey lighten-3'
    },
    access: {
      default: true
    },
    showBackButton: {
      default: true
    }
  }
};
</script>
